(function () {
  'use strict';

  if (customElements.get('tire-model-variants-mobile')) return;

  function text(value) {
    return value == null ? '' : String(value);
  }

  function numberSort(a, b) {
    return Number(a) - Number(b);
  }

  function localUrl(root, url) {
    var cleanRoot = text(root || '/').replace(/\/$/, '');
    var cleanUrl = text(url || '/');
    if (!cleanRoot || cleanRoot === '/' || cleanUrl.indexOf(cleanRoot + '/') === 0) return cleanUrl;
    return cleanRoot + (cleanUrl.charAt(0) === '/' ? cleanUrl : '/' + cleanUrl);
  }

  function modelBase(model, oe) {
    var value = text(model).trim().replace(/\s+/g, ' ');
    var suffix = text(oe).trim();
    if (suffix) {
      var escaped = suffix.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      value = value.replace(new RegExp('\\s+' + escaped + '$', 'i'), '').trim();
    }
    return value.toLocaleLowerCase();
  }

  function broadTags(model) {
    var blocked = { ALL: true, SEASON: true, SOMMER: true, WINTER: true, TYRE: true, TIRE: true };
    var matches = text(model).toUpperCase().match(/[A-Z0-9][A-Z0-9+.-]*/g) || [];
    return matches.filter(function (part) {
      return part.length >= 3 && !/^\d+$/.test(part) && !blocked[part];
    }).slice(0, 3);
  }

  class TireModelVariantsMobile extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return;
      this.dataset.ready = 'true';
      this.controls = this.querySelector('[data-tmvm-controls]');
      this.sizes = this.querySelector('[data-tmvm-sizes]');
      this.results = this.querySelector('[data-tmvm-results]');
      this.count = this.querySelector('[data-tmvm-count]');
      try {
        this.currentProduct = JSON.parse(this.querySelector('[data-tmvm-current]')?.textContent || 'null');
      } catch (error) {
        this.currentProduct = null;
      }
      this.setupTrustPosition();
      this.setupVehicleCheck();
      this.load();
    }

    setupVehicleCheck() {
      var links = document.querySelectorAll('[data-vantiq-product-v2] a[data-v2-vehicle-check], [data-vantiq-product-v2] .v2pdp__pills a[href="/pages/fahrzeugsuche"]');
      if (!links.length) return;

      links.forEach(function (link) {
        // Von der Produktsection schon verdrahtet (sprachsicherer Link).
        if (link.dataset.v2Bound) return;
        // Die frühere Zielseite existiert nicht. Ohne verfügbaren Dialog ist
        // die Fahrzeugsuche auf der Startseite der funktionierende Rückfall.
        link.setAttribute('data-v2-vehicle-check', '');
        link.setAttribute('href', '/#suche');
        link.addEventListener('click', function (event) {
          var opener = document.querySelector('[data-rolle="fahrzeug-waehlen"]');
          if (!opener) return;
          event.preventDefault();
          opener.click();
        });
      });
    }

    setupTrustPosition() {
      var trustCard = document.querySelector('[data-vantiq-product-v2] .v2pdp__trust-card');
      var mobileContainer = document.querySelector('[data-v2-mobile-fitment-section] .v2pdp__wrap') || this.closest('.tmvm-section__inner');
      if (!trustCard || !mobileContainer) return;

      var placeholder = document.createElement('span');
      placeholder.hidden = true;
      trustCard.parentNode.insertBefore(placeholder, trustCard);

      var mobileQuery = window.matchMedia('(max-width: 749px)');
      var syncPosition = function () {
        if (mobileQuery.matches) {
          mobileContainer.appendChild(trustCard);
        } else if (placeholder.parentNode) {
          placeholder.parentNode.insertBefore(trustCard, placeholder.nextSibling);
        }
      };

      syncPosition();
      if (mobileQuery.addEventListener) mobileQuery.addEventListener('change', syncPosition);
      else mobileQuery.addListener(syncPosition);

      var fitmentHelp = document.querySelector('[data-vantiq-product-v2] .v2pdp__help');
      var fitmentHelpCopy = fitmentHelp?.querySelector('.v2pdp__help-copy');
      var fitmentSource = document.querySelector('[data-vantiq-product-v2] .v2pdp__support:not(.v2pdp__support--mobile-slot)');
      var fitmentCard = document.querySelector('[data-v2-mobile-fitment-slot] article') || fitmentSource?.querySelector('article:last-child');
      var fitmentActions = fitmentCard?.querySelector('.v2pdp__pills');
      if (!fitmentHelp || !fitmentHelpCopy || !fitmentSource || !fitmentCard || !fitmentActions) return;

      var emailLink = fitmentHelp.querySelector('.v2pdp__help-email');
      // Seit 17.09.2026 rendert die Produktsection die Karte mehrsprachig;
      // der Nachbau hier greift nur noch, wenn sie fehlt.
      if (!document.querySelector('[data-vantiq-product-v2] .v2pdp__mobile-fitment-card')) {
        var mobileFitment = document.createElement('section');
        mobileFitment.className = 'v2pdp__mobile-fitment-card';
        mobileFitment.setAttribute('aria-labelledby', 'v2pdp-mobile-fitment-title');
        mobileFitment.innerHTML =
          '<h3 id="v2pdp-mobile-fitment-title">Passt diese Grösse zu deinem Auto?</h3>' +
          '<p class="v2pdp__mobile-fitment-intro">Zwei Wege, beide dauern keine Minute.</p>' +
          '<div class="v2pdp__mobile-fitment-options">' +
            '<a href="/#suche" data-v2-vehicle-check class="v2pdp__mobile-fitment-option">' +
              '<span class="v2pdp__mobile-fitment-icon" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M4 15l1.4-4.6A2 2 0 0 1 7.3 9h9.4a2 2 0 0 1 1.9 1.4L20 15"/><path d="M3 15h18v3H3z"/><circle cx="7" cy="18.5" r="1.2"/><circle cx="17" cy="18.5" r="1.2"/></svg></span>' +
              '<span class="v2pdp__mobile-fitment-copy"><strong>Ich kenne mein Auto</strong><small>Marke, Modell, Baujahr</small></span>' +
              '<span class="v2pdp__mobile-fitment-arrow" aria-hidden="true">→</span>' +
            '</a>' +
            '<a href="/pages/typenschein" class="v2pdp__mobile-fitment-option">' +
              '<span class="v2pdp__mobile-fitment-icon" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="4" y="3" width="16" height="18" rx="2"/><path d="M8 8h8M8 12h6"/></svg></span>' +
              '<span class="v2pdp__mobile-fitment-copy"><strong>Ich habe die Typenschein-Nr.</strong><small>Fahrzeugausweis, Ziffer 24</small></span>' +
              '<span class="v2pdp__mobile-fitment-arrow" aria-hidden="true">→</span>' +
            '</a>' +
          '</div>' +
          '<p class="v2pdp__mobile-fitment-contact">Unsicher? Wir prüfen die Passform vor der Bestellung — <a href="' + (emailLink?.getAttribute('href') || 'mailto:info@vantiq.ch') + '">per E-Mail</a> oder <a href="tel:+41445458442">044 545 84 42</a></p>';
        fitmentHelp.parentNode.insertBefore(mobileFitment, fitmentHelp);
      }

      var syncHelpPosition = function () {
        if (mobileQuery.matches) {
          fitmentHelp.hidden = true;
          fitmentSource.appendChild(fitmentCard);
        } else {
          fitmentHelp.hidden = false;
          fitmentSource.appendChild(fitmentCard);
        }
      };

      syncHelpPosition();
      if (mobileQuery.addEventListener) mobileQuery.addEventListener('change', syncHelpPosition);
      else mobileQuery.addListener(syncHelpPosition);
    }

    async load() {
      var vendorTag = "tag:'" + this.dataset.vendor.replace(/'/g, '') + "'";
      var exactQuery = vendorTag + " AND tag:'" + this.dataset.modelTag.replace(/'/g, '') + "'";
      var words = broadTags(this.dataset.modelBase || this.dataset.model);
      var broadQuery = words.length ? vendorTag + ' AND ' + words.map(function (word) {
        return "tag:'" + word.replace(/'/g, '') + "'";
      }).join(' AND ') : exactQuery;
      var endpoint = this.dataset.endpoint || '/search';

      try {
        var families = await Promise.all([this.fetchFamily(endpoint, exactQuery), this.fetchFamily(endpoint, broadQuery)]);
        var merged = new Map();
        families.flat().forEach(function (product) { merged.set(product.handle, product); });
        if (this.currentProduct?.handle) merged.set(this.currentProduct.handle, this.currentProduct);
        var expectedModel = modelBase(this.dataset.modelBase || this.dataset.model, '');
        var expectedVendor = text(this.dataset.vendor).toLocaleLowerCase();
        this.products = Array.from(merged.values()).filter(function (product) {
          return text(product.vendor).toLocaleLowerCase() === expectedVendor && modelBase(product.model, product.oe) === expectedModel;
        }).sort(function (a, b) {
          return numberSort(a.rim, b.rim) || numberSort(a.width, b.width) || numberSort(a.aspect, b.aspect) || numberSort(a.price, b.price);
        });

        if (!this.products.length) {
          this.count.textContent = this.dataset.labelEmpty;
          return;
        }

        this.controls.hidden = false;
        this.populateSizes();
        this.render();
      } catch (error) {
        this.count.textContent = this.dataset.labelError;
        this.results.innerHTML = '';
        console.warn('[VANTIQ] Mobile Modellvarianten:', error);
      }
    }

    async fetchFamily(endpoint, query) {
      var base = endpoint + '?view=tire-variants&type=product&q=' + encodeURIComponent(query);
      var products = [];
      var pages = 1;
      for (var page = 1; page <= pages && page <= 5; page++) {
        var response = await fetch(base + (page > 1 ? '&page=' + page : ''), { headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error('HTTP ' + response.status);
        var payload = await response.json();
        products = products.concat(payload.products || []);
        pages = Math.max(1, Number(payload.pages) || 1);
      }
      return products;
    }

    dimensionKey(product) {
      return [product.width, product.aspect, product.rim].map(text).join('|');
    }

    populateSizes() {
      var currentKey = [this.dataset.currentWidth, this.dataset.currentAspect, this.dataset.currentRim].join('|');
      var dimensions = new Map();
      this.products.forEach((product) => dimensions.set(this.dimensionKey(product), product));
      var entries = Array.from(dimensions.entries()).sort(function (a, b) {
        if (a[0] === currentKey) return -1;
        if (b[0] === currentKey) return 1;
        return numberSort(a[1].rim, b[1].rim) || numberSort(a[1].width, b[1].width) || numberSort(a[1].aspect, b[1].aspect);
      });
      this.selectedDimension = dimensions.has(currentKey) ? currentKey : entries[0]?.[0];
      this.sizes.innerHTML = '';
      entries.forEach(([key, product]) => {
        var option = document.createElement('option');
        option.value = key;
        option.textContent = product.width + '/' + product.aspect + ' R' + product.rim;
        this.sizes.appendChild(option);
      });
      this.sizes.value = this.selectedDimension;
      this.sizes.addEventListener('change', () => {
        this.selectedDimension = this.sizes.value;
        this.render();
      });
    }

    render() {
      var selected = this.selectedDimension;
      var matches = this.products.filter((product) => this.dimensionKey(product) === selected);
      this.count.textContent = this.products.length + ' ' + (this.products.length === 1 ? this.dataset.labelCountSingular : this.dataset.labelCountPlural);
      this.results.innerHTML = '';
      if (!matches.length) {
        var empty = document.createElement('p');
        empty.className = 'tmvm__empty';
        empty.textContent = this.dataset.labelEmpty;
        this.results.appendChild(empty);
        return;
      }
      matches.forEach((product) => this.results.appendChild(this.card(product)));
    }

    card(product) {
      var current = product.handle === this.dataset.currentHandle;
      var link = document.createElement('a');
      link.className = 'tmvm-card' + (current ? ' tmvm-card--current' : '');
      link.href = localUrl(this.dataset.root, product.url);
      if (current) link.setAttribute('aria-current', 'page');

      var size = document.createElement('span');
      size.className = 'tmvm-card__size';
      size.textContent = product.width + '/' + product.aspect + ' R' + product.rim;
      if (current) {
        var badge = document.createElement('span');
        badge.className = 'tmvm-card__badge';
        badge.textContent = this.dataset.labelCurrent;
        size.appendChild(badge);
      }

      var meta = document.createElement('span');
      meta.className = 'tmvm-card__meta';
      var detail = [text(product.load) + text(product.speed), product.xl ? 'XL' : '', text(product.oe)].filter(Boolean);
      meta.textContent = detail.length ? this.dataset.labelLoad + ': ' + detail.join(' · ') : '';

      var price = document.createElement('span');
      price.className = 'tmvm-card__price';
      var locale = this.dataset.locale || 'de';
      if (locale.length === 2) locale += '-CH';
      price.textContent = new Intl.NumberFormat(locale, { style: 'currency', currency: this.dataset.currency || 'CHF' }).format(Number(product.price || 0) / 100);

      var stock = document.createElement('span');
      stock.className = 'tmvm-card__stock';
      stock.textContent = product.available ? this.dataset.labelInStock : this.dataset.labelUnavailable;

      link.append(size, meta, price, stock);
      return link;
    }

    // Das ProductGroup-Markup schrieb früher dieses Skript. Es steht seit dem
    // 16.09.2026 serverseitig in snippets/tire-product-schema.liquid: Hier
    // hängte es alle Grössen als eigene Produkte an jede Seite.
  }

  customElements.define('tire-model-variants-mobile', TireModelVariantsMobile);
})();
